import { Send } from '@mui/icons-material';
import LoadingButton from '@mui/lab/LoadingButton';
import { Box, Button, TextField } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSendDeviceCommand } from '~/api/devices';
import { DeviceCommandKind, type DeviceBulkSelectionInput } from '~/generated/graphql';
import { Dialog, DialogTitle } from '../dialogs/components';
import { DialogActions, DialogContent } from '../dialogs/lib/styles';

export interface ArbitraryCommandDialogProps {
  onClose: () => void;
  onComplete?: () => void;
  open: boolean;
  selected: DeviceBulkSelectionInput;
}

export const ArbitraryCommandDialog = ({
  onClose,
  onComplete,
  open,
  selected,
}: ArbitraryCommandDialogProps) => {
  const { t } = useTranslation();
  const [arbitrary, setArbitrary] = useState('');
  const [sendCommand, { loading }] = useSendDeviceCommand();

  return (
    <Dialog
      maxWidth="xs"
      fullWidth
      onClose={onClose}
      open={open}
      TransitionProps={{ onExited: () => setArbitrary('') }}
    >
      <DialogTitle onClose={onClose}>{t('components.arbitrary_command_dialog.title')}</DialogTitle>

      <DialogContent>
        <Box display="flex" alignItems="center" justifyContent="center" padding={2}>
          <TextField
            autoFocus
            fullWidth
            label={t('components.arbitrary_command_dialog.label')}
            onChange={(e) => setArbitrary(e.target.value)}
            value={arbitrary}
            variant="outlined"
          />
        </Box>
      </DialogContent>

      <DialogActions>
        <Button variant="outlined" onClick={onClose}>
          {t('common.actions.cancel')}
        </Button>
        <LoadingButton
          color="primary"
          disabled={arbitrary.trim() === ''}
          loading={loading}
          loadingPosition="start"
          onClick={async () => {
            await sendCommand({
              variables: {
                input: {
                  command: DeviceCommandKind.Arbitrary,
                  payload: { arbitrary: arbitrary.trim() },
                  selected,
                },
              },
            });
            onComplete?.();
            onClose();
          }}
          startIcon={<Send />}
          variant="contained"
        >
          {t('components.arbitrary_command_dialog.send_button')}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
